import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { GridColumn, GridRow } from '../../../components/Reusable/Grid'

export const EvidenceGridColumn = styled(GridColumn)`
  justify-content: space-evenly;
  p {
    display: flex;
    justify-content: center;
    width: 70px;
  }
`

export const PolicyGridColumn = styled(GridColumn)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const RightAlignGridColumn = styled(GridColumn)`
  justify-content: right;
`

export const SpinnerContainer = styled.div`
  width: 100%;
  padding-left: 1.5em;
`

export const ControlGridRow = styled(GridRow)<{ isNotApplicable?: boolean }>`
  ${({ isNotApplicable }) =>
    isNotApplicable &&
    `
>.grid-column {
  background-color: ${palette.neutral['50']}; 
}
&:hover {
  >.grid-column {
  background-color: ${palette.neutral['100']};
  }
}`}
`
